import React from 'react';
import ReactDOM from 'react-dom';
import KeepNote from './KeepNote';
import './index.css';

ReactDOM.render(
  <KeepNote />, document.getElementById('root')
);